import TotalRaisedLayout from './TotalRaisedLayout';
import ChartUtilities from './ChartUtilities';
import { ReactNode, useState } from 'react';

interface IProps {
	page: string;
	title: string | ReactNode;
	text: string | ReactNode;
}
const TotalRaisedSection = ({ ...props }: IProps) => {
	const [accordionIndex, setAccordionIndex] = useState<number | null>(null);

	return (
		<>
			<TotalRaisedLayout
				{...props}
				accordionIndex={accordionIndex}
				setAccordionIndex={setAccordionIndex}
			/>
			<ChartUtilities
				component={
					<TotalRaisedLayout
						{...props}
						accordionIndex={accordionIndex}
						setAccordionIndex={setAccordionIndex}
						print={true}
					/>
				}
				title={props.title}
				page={props.page}
			/>
		</>
	);
};

export default TotalRaisedSection;
